module.exports = __webpack_public_path__ + "img/MasterCard.dc337432.png";